var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotfound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.056 430.887C376.287 430.887 475.374 417.145 475.374 400.194C475.374 383.243 376.287 369.501 254.056 369.501C131.826 369.501 32.7383 383.243 32.7383 400.194C32.7383 417.145 131.826 430.887 254.056 430.887Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333.463 381.014H200.126L212.967 292.843H320.622L333.463 381.014Z",
    fill: "#96B1D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M432.578 308.388H101.011C92.5868 308.388 85.7578 301.559 85.7578 293.135V84.253C85.7578 75.829 92.5868 69 101.011 69H432.578C441.002 69 447.831 75.829 447.831 84.253V293.135C447.831 301.559 441.002 308.388 432.578 308.388Z",
    fill: "#003F8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M423.792 283.273H109.797C101.373 283.273 94.5439 276.444 94.5439 268.02V91.46C94.5439 83.036 101.373 76.207 109.797 76.207H423.793C432.217 76.207 439.046 83.036 439.046 91.46V268.02C439.046 276.444 432.217 283.273 423.792 283.273Z",
    fill: "#7BB68D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M361.724 387.434H171.864V378.262C171.864 371.17 177.613 365.421 184.705 365.421H348.883C355.975 365.421 361.724 371.17 361.724 378.262V387.434Z",
    fill: "#003F8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.776 283.273H421.445",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.222 382.848V378.033C180.222 375.12 182.583 372.759 185.496 372.759H327.891",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M312.757 315.434L317.801 353.957",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M263.61 303.997C267.689 303.997 270.997 300.69 270.997 296.61C270.997 292.53 267.689 289.223 263.61 289.223C259.53 289.223 256.223 292.53 256.223 296.61C256.223 300.69 259.53 303.997 263.61 303.997Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M368.706 90.2622H407.916C415.388 90.2622 421.445 96.3192 421.445 103.791V185.262",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M131.217 117.55C131.489 115.406 131.869 113.702 132.357 112.439C132.846 111.175 133.625 110.063 134.695 109.103C135.316 108.524 135.996 108.045 136.738 107.667C137.478 107.29 138.169 106.878 138.81 106.43C139.45 105.984 140.008 105.46 140.486 104.86C140.963 104.261 141.269 103.435 141.403 102.381C141.628 100.6 141.302 99.2876 140.424 98.4443C139.546 97.6011 138.443 97.0868 137.117 96.9022C135.217 96.6379 133.841 96.9922 132.988 97.9641C132.135 98.9368 131.504 100.319 131.094 102.111L124.158 101.146C124.384 99.3656 124.875 97.7878 125.633 96.4138C126.391 95.0403 127.363 93.918 128.55 93.0472C129.736 92.1774 131.108 91.5727 132.665 91.2345C134.221 90.8964 135.895 90.8521 137.688 91.1016C141.56 91.6404 144.514 92.8656 146.552 94.7764C148.589 96.6879 149.381 99.4419 148.924 103.04C148.777 104.204 148.531 105.204 148.188 106.044C147.844 106.884 147.394 107.626 146.839 108.27C146.282 108.913 145.625 109.497 144.866 110.02C144.106 110.544 143.255 111.072 142.312 111.606C141.444 112.115 140.736 112.599 140.185 113.058C139.634 113.518 139.196 114.021 138.872 114.567C138.547 115.114 138.309 115.701 138.157 116.326C138.004 116.952 137.878 117.666 137.777 118.464L131.217 117.55ZM129.668 128.042L130.573 120.9L137.832 121.911L136.927 129.053L129.668 128.042Z",
    fill: "#003F8C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M289.657 143.306V128.486C289.657 123.625 285.716 119.684 280.855 119.684H194.827C189.966 119.684 186.025 123.625 186.025 128.486V143.306V242.038C186.025 246.899 189.966 250.84 194.827 250.84H332.394C337.255 250.84 341.196 246.899 341.196 242.038V152.108C341.196 147.247 337.255 143.306 332.394 143.306H289.657Z",
    fill: "#003F8C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M280.942 164.006L263.61 181.338L246.279 164.007L235.82 174.465L253.151 191.797L235.82 209.129L246.279 219.587L263.61 202.256L280.942 219.587L291.401 209.129L274.069 191.797L291.401 174.465L280.942 164.006Z",
    fill: "#009A2E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8206 386.579V375.168H54.8066V406.547L102.255 407.308V401.603L75.8206 386.579Z",
    fill: "#F7A99C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.934 407.308V404.603C103.934 401.837 102.417 399.295 99.9832 397.981L79.9721 387.181C73.9731 388.82 69.3372 388.59 66.1692 388.053C60.9082 387.16 55.8802 384.77 54.1882 386.769C53.7042 387.341 53.6462 388.091 53.6652 388.607V405.2C53.6652 406.364 54.6092 407.308 55.7732 407.308H103.934Z",
    fill: "#003F8C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.934 405.501H53.6641",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.858 394.363L90.042 398.085",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7955 393.198L87.9795 396.92",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6402 392.119L85.8232 395.84",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.466 390.146C82.056 391.447 76.428 393.115 69.323 393.077C62.468 393.04 57.027 391.429 53.665 390.146",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.725 386.579V375.168H114.711V406.547L162.159 407.308V401.603L135.725 386.579Z",
    fill: "#F7A99C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M163.839 407.308V404.603C163.839 401.837 162.322 399.295 159.888 397.981L139.877 387.181C133.878 388.82 129.242 388.59 126.074 388.053C120.813 387.16 115.785 384.77 114.093 386.769C113.609 387.341 113.551 388.091 113.57 388.607V405.2C113.57 406.364 114.514 407.308 115.678 407.308H163.839Z",
    fill: "#003F8C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M163.839 405.501H113.57",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M152.763 394.363L149.947 398.085",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M150.701 393.198L147.885 396.92",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M148.546 392.119L145.729 395.84",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M145.371 390.146C141.961 391.447 136.333 393.115 129.228 393.077C122.374 393.04 116.932 391.429 113.57 390.146",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M123.649 224.074C123.649 224.074 140.955 279.035 143.617 286.642C146.279 294.249 148.752 304.899 148.181 314.217C147.61 323.536 138.672 380.968 138.672 380.968H112.618C112.618 380.968 110.778 320.302 109.891 315.548C109.004 310.794 101.397 283.901 101.397 283.901C101.397 283.901 98.9251 315.358 96.8331 323.725C94.7411 332.093 78.0061 381.919 78.0061 381.919H53.6641L63.9341 224.074H123.649Z",
    fill: "#009A2E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M163.368 190.57C163.368 190.57 171.631 183.56 173.722 178.974C175.512 175.049 178.014 168.153 178.698 166.247C178.801 165.959 179.103 165.8 179.4 165.87L179.895 165.987C181.428 166.35 182.375 167.89 182.007 169.422L181.182 172.86L189.913 167.126C190.662 166.634 191.671 166.876 192.115 167.655C192.507 168.342 192.32 169.214 191.681 169.679L185.922 173.879L195.489 169.387C196.23 169.039 197.113 169.319 197.519 170.03L197.531 170.051C197.96 170.804 197.698 171.762 196.945 172.191L197.052 172.16C197.883 171.921 198.764 172.324 199.126 173.108C199.546 174.016 199.12 175.09 198.193 175.465L197.584 175.711C198.378 175.463 199.212 175.958 199.374 176.774C199.611 177.965 199.037 179.168 197.96 179.729C195.385 181.069 193.714 181.422 191.267 183.254C189.33 184.703 190.008 185.626 187.942 188.269C185.426 191.488 183.283 191.579 178.949 194.765C177.303 195.975 175.03 197.861 172.628 200.668L163.368 190.57Z",
    fill: "#F7A99C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M192.255 168C192.255 168 192.694 168.89 191.86 169.524C191.027 170.158 184.521 174.974 184.521 174.974",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M196.945 172.191L187.987 176.349",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M197.867 175.657L188.861 179.802",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M180.521 166.219C180.521 166.219 182.095 167.215 182.051 168.319C182.007 169.423 180.419 176.515 180.419 176.515",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M112.619 380.969C112.619 380.969 110.261 318.765 110.077 317.157C109.893 315.549 101.028 282.625 101.028 282.625L102.598 268.073C102.598 268.073 120.483 312.099 120.483 315.003C120.483 317.908 122.47 380.969 122.47 380.969H112.619Z",
    fill: "#0D6327"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8486 319.918L104.205 251.175",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M139.674 375.691H112.418L112.619 380.969H138.673L139.674 375.691Z",
    fill: "#262626"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5861 377.205H53.9711L53.6641 381.92H78.0071L79.5861 377.205Z",
    fill: "#262626"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M141.26 292.077C144.709 302.934 145.256 314.698 142.828 325.828",
    stroke: "white",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M170.237 183.178C170.237 183.178 165.825 186.575 160.799 187.457C154.91 188.491 149.803 185.003 148.432 184.067C144.698 181.517 143.319 178.496 140.85 174.961C133.536 164.491 128.993 157.987 122.633 154.304C119.346 152.4 113.849 150.251 105.183 150.916C103.239 150.219 100.14 150.771 98.064 150.771C96.338 150.771 94.613 150.771 92.887 150.771C89.485 151.179 64.429 154.09 60.169 150.178C58.49 148.636 58.463 147.117 58.463 147.117C58.441 145.861 59.234 144.554 61.31 142.973C66.383 139.11 75.689 136.226 78.806 135.307L76.904 121.103C76.904 121.103 76.904 121.103 72.72 121.103C68.536 121.103 53.702 123.575 45.715 126.366C34.516 130.279 28.516 133.135 25.556 139.622C21.848 147.751 25.798 156.488 26.824 158.758C31.966 170.131 43.368 174.734 50.255 177.514C56.329 179.966 61.735 180.951 65.493 181.389L62.26 233.117L121.716 236.35H130.645C131.329 228.446 127.909 203.888 128.352 195.866C135.943 206.43 148.517 211.765 160.454 209.471C173.669 206.932 180.315 196.156 181.397 194.337C176.785 185.238 170.237 183.178 170.237 183.178Z",
    fill: "#003F8C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.366 179.431H95.793V154.743H99.538V176.259C99.538 178.011 98.118 179.431 96.366 179.431Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M130.736 233.622C128.688 234.002 100.545 238.721 80.6587 217.724C63.8787 200.007 65.8627 177.586 66.2127 174.27C65.1687 189.822 64.1237 205.374 63.0797 220.926H63.0227L62.2607 233.116L71.5807 233.623L71.5747 233.557C85.4747 234.657 99.8197 235.478 114.589 235.962C119.999 236.139 125.352 236.267 130.647 236.35C130.676 235.44 130.706 234.531 130.736 233.622Z",
    fill: "#0F335E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M114.97 132.083C115.989 126.853 115.83 122.765 115.534 120.152C115.309 118.164 114.963 116.659 113.907 115.228C113.684 114.926 111.93 112.62 108.92 112.018C105.32 111.297 104.411 113.912 99.2902 114.546C94.8742 115.092 94.0042 113.339 91.0342 114.598C87.7902 115.973 86.1892 119.184 85.7032 120.159C85.4912 120.585 84.4342 122.763 84.3272 125.815C84.2422 128.232 84.7942 130.05 85.0132 130.794C85.9332 133.925 87.0162 138.687 88.3402 146.3C89.0312 146.274 89.7232 146.249 90.4142 146.223C98.6002 141.508 106.785 136.795 114.97 132.083Z",
    fill: "#262626"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M97.461 157.805C93.593 157.82 90.446 154.696 90.432 150.829L90.375 135.759L104.381 135.706L104.438 150.776C104.452 154.643 101.329 157.79 97.461 157.805Z",
    fill: "#F7A99C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M104.422 146.557L95.3008 141.871C95.3928 142.661 95.9118 146.36 99.1648 148.915C101.242 150.546 103.426 150.919 104.434 151.025L104.422 146.557Z",
    fill: "#FF7769"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0354 131.09C89.9914 130.862 89.3914 130.518 89.2074 130.401C88.8964 130.202 88.5594 130.043 88.2074 129.93C87.5244 129.71 86.7734 129.659 86.0714 129.82C84.6754 130.14 83.4374 131.313 83.2044 132.75C83.0694 133.585 83.2624 134.448 83.6194 135.214C84.1574 136.366 85.0694 137.334 86.1714 137.968C87.0844 138.494 88.1234 138.792 89.1734 138.854C89.3834 138.866 91.5364 138.817 91.5204 138.734C91.0244 136.186 90.5294 133.638 90.0354 131.09Z",
    fill: "#F7A99C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1155 131.236C88.2815 132.36 89.2695 138.291 94.6155 142.481C95.6005 143.253 102.146 148.384 108.136 145.88C115.833 142.662 114.993 130.02 114.939 129.335C114.756 127.02 114.215 120.203 108.57 116.566C103.963 113.598 98.9705 114.689 98.2625 114.856C97.5165 115.031 92.7635 116.231 89.8545 120.891C87.2135 125.12 87.8445 129.396 88.1155 131.236Z",
    fill: "#F7A99C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M110.57 129.344C110.694 130.331 111.455 131.048 112.27 130.946C113.085 130.844 113.645 129.961 113.521 128.974C113.397 127.987 112.636 127.27 111.821 127.372C111.006 127.474 110.446 128.357 110.57 129.344Z",
    fill: "#262626"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M101.676 130.461C101.8 131.448 102.561 132.165 103.376 132.063C104.191 131.961 104.751 131.078 104.627 130.091C104.503 129.104 103.742 128.387 102.927 128.489C102.113 128.591 101.552 129.474 101.676 130.461Z",
    fill: "#262626"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M107.885 130.821L109.248 132.663C109.499 133.001 109.405 133.482 109.045 133.701L107.793 134.463",
    stroke: "#262626",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6937 135.11C98.8327 136.217 99.8437 137.003 100.951 136.863C102.058 136.724 102.844 135.713 102.704 134.606C102.565 133.499 101.554 132.713 100.447 132.853C99.3397 132.992 98.5547 134.003 98.6937 135.11Z",
    fill: "#FF7769"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0953 136.154C89.1023 135.932 89.1203 134.428 87.9143 133.343C86.9693 132.493 85.8693 132.437 85.5693 132.432",
    stroke: "#262626",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M88.031 133.641C87.964 133.63 87.155 133.518 86.59 134.13C86.125 134.633 86.168 135.255 86.177 135.358",
    stroke: "#262626",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9388 129.855C87.9388 129.855 88.9338 129.943 89.6838 130.688C90.4338 131.432 90.6998 132.707 90.6998 132.707C92.6168 132.474 97.0078 131.665 100.991 128.208C103.15 126.334 104.468 124.308 105.245 122.847C105.971 123.5 107.21 124.481 108.963 125.237C111.25 126.223 114.107 126.695 114.486 125.927C114.556 125.785 114.479 125.373 114.323 124.55C114.267 124.252 114.208 123.811 114.063 123.389C113.78 122.563 113.412 121.766 112.973 121.011C112.093 119.501 110.922 118.16 109.544 117.085C108.648 116.387 107.665 115.801 106.619 115.356C103.299 113.944 98.6888 113.943 94.7208 116.059C94.7208 116.059 90.2908 118.422 88.3378 123.046C87.6668 124.635 87.4978 126.224 87.4558 126.775C87.3718 127.866 87.4948 128.579 87.6608 129.127C87.7548 129.437 87.8598 129.686 87.9388 129.855Z",
    fill: "#262626"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M113.89 131.914C114.273 131.866 114.642 131.934 114.97 132.083C114.931 133.168 114.827 134.484 114.588 135.88C114.523 135.895 114.461 135.916 114.394 135.925C113.287 136.064 112.276 135.279 112.137 134.172C111.998 133.065 112.782 132.053 113.89 131.914Z",
    fill: "#FF7769"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0605 115.113C98.4025 114.857 97.4385 114.508 96.2515 114.167C93.6495 113.421 92.3485 113.048 91.1645 113.2C87.6985 113.645 85.7075 118.213 84.8725 120.129C84.2405 121.579 83.2065 124.04 83.7545 127.123C83.9985 128.495 84.4815 129.568 84.8655 130.277",
    stroke: "#262626",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0605 114.701C100.233 114.189 101.486 113.774 102.615 113.187C103.8 112.571 104.835 111.77 106.104 111.297C107.437 110.8 108.925 110.601 110.286 111.014C111.459 111.37 112.462 112.154 113.29 113.058C114.405 114.276 115.254 115.746 115.696 117.337C116.548 120.403 115.787 123.598 115.285 126.654",
    stroke: "#262626",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M109.39 138.682C109.39 139.678 108.42 140.485 107.224 140.485C106.027 140.485 105.057 139.678 105.057 138.682C105.057 137.686 106.027 136.879 107.224 136.879C108.42 136.88 109.39 137.687 109.39 138.682Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2314 123.54L81.2324 121.103C81.2324 121.103 82.0494 117.578 83.1604 116.833C84.2714 116.088 90.1754 113.795 90.1754 113.795L91.0354 114.598C91.0354 114.598 86.4154 118.818 85.4584 120.692C84.5004 122.566 84.3204 127.783 84.3204 127.783L79.8004 133.627L78.6944 134.464L77.2314 123.54Z",
    fill: "#F7A99C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2134 176.515L64.1094 203.548",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M127.321 178.725L128.934 208.552",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9523 136.154C34.1163 136.819 29.7923 140.396 29.0923 146.715C28.3303 153.599 32.4703 158.311 33.1173 159.023",
    stroke: "white",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 197.852C138.79 199.087 143.114 203.594 150.38 204.576C157.271 205.508 162.412 202.676 163.894 201.788",
    stroke: "white",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M326.602 221.535L335.877 216.577L349.635 219.099L356.514 211.761L372.794 216.118L381.852 203.736L398.026 213.65L392.523 178.687L371.181 163.744L322.129 171.464C320.292 171.753 319.038 173.476 319.327 175.313L326.602 221.535Z",
    fill: "#009A2E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M376.166 181.261L392.523 178.687L371.181 163.744L373.65 179.429C373.838 180.63 374.965 181.45 376.166 181.261Z",
    fill: "#D6D6D6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 163.743L373.65 179.428C373.839 180.629 374.966 181.449 376.167 181.26L392.524 178.686",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M333.214 267.442C333.503 269.279 335.226 270.533 337.063 270.244L401.32 260.131C403.157 259.842 404.411 258.119 404.122 256.282L398.026 217.548L381.852 207.634L372.794 220.016L356.514 215.659L349.635 222.997L335.877 220.475L326.602 225.433L333.214 267.442Z",
    fill: "#009A2E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M326.614 221.535L335.889 216.577L349.647 219.099L356.526 211.761L372.806 216.118L381.864 203.736L398.038 213.65L392.535 178.687L371.193 163.744L322.141 171.464C320.304 171.753 319.05 173.476 319.339 175.313L326.614 221.535Z",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M333.226 267.442C333.515 269.279 335.238 270.533 337.075 270.244L401.332 260.131C403.169 259.842 404.423 258.119 404.134 256.282L398.038 217.548L381.864 207.634L372.806 220.016L356.526 215.659L349.647 222.997L335.889 220.475L326.614 225.433L333.226 267.442Z",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0237 112.787L76.4017 114.335L62.0537 101.38L66.1837 97.4409L78.0237 112.787Z",
    fill: "#FF7129"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5694 110.131L79.3644 110.539L74.4434 91.8451L80.0554 90.8081L81.5694 110.131Z",
    fill: "#FF7129"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9232 116.313L73.7392 118.548L54.4082 118.402L54.8772 112.714L73.9232 116.313Z",
    fill: "#FF7129"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M304.872 399.75C300.022 394.983 299.954 387.187 304.721 382.337L361.414 324.65L378.978 341.912L322.285 399.598C317.518 404.449 309.722 404.517 304.872 399.75Z",
    fill: "#009A2E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M406.03 346.726C433.528 346.663 455.769 324.319 455.705 296.821C455.642 269.323 433.299 247.082 405.801 247.146C378.302 247.209 356.062 269.552 356.125 297.05C356.189 324.549 378.532 346.789 406.03 346.726Z",
    fill: "#DCF0FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M359.309 314.496C360.988 318.963 363.328 323.235 366.333 327.16L455.683 296.255C455.616 291.424 454.847 286.604 453.384 281.956L359.309 314.496Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.231 300.239C356.417 303.064 356.844 305.874 357.51 308.639L451.183 276.239C450.015 273.684 448.624 271.209 447.002 268.843L356.231 300.239Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M371.867 263.498L372.153 263.778L371.867 263.498C353.393 282.296 353.656 312.51 372.453 330.984C391.251 349.458 421.466 349.196 439.939 330.398C458.413 311.6 458.151 281.386 439.353 262.912C420.555 244.438 390.341 244.7 371.867 263.498ZM445.9 256.25L446.181 255.965L445.9 256.25C468.378 278.339 468.691 314.468 446.601 336.946C424.511 359.423 388.382 359.737 365.906 337.647L365.626 337.932L365.906 337.647C343.429 315.557 343.115 279.428 365.205 256.951L364.92 256.671L365.205 256.951C387.295 234.474 423.424 234.16 445.9 256.25Z",
    fill: "#009A2E",
    stroke: "black",
    strokeWidth: 0.8
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M365.393 347.219L320.565 392.832",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M410.024 243.615C395.9 242.19 381.257 247.065 370.805 256.671C360.353 266.278 354.264 280.459 354.496 294.653",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/not found.05a7ab791e4d38a08892f0f9b416e246.svg";
export { ForwardRef as ReactComponent };